import React, { PropsWithChildren } from 'react';

import { HeaderButton } from '../header-button/HeaderButton.view';
import MenuToggler from '../menu-toggler';
import { UserAvatarContainer } from '../user-avatar/UserAvatar.container';

import { TestID } from '../../testID';

import './UserMenu.css';

const anchorPoint = {
  anchor: { hPos: 'right', vPos: 'bottom' },
  popover: { hPos: 'right', vPos: 'top' },
};

export const UserMenuToggler: React.FC<
  PropsWithChildren<{
    darkModeActive: boolean;
    email: string;
    userName: string;
  }>
> = ({ children, darkModeActive, email, userName }) => (
  // @ts-ignore
  <HeaderButton className="user-menu" darkModeActive={darkModeActive}>
    <MenuToggler
      anchorPoint={anchorPoint}
      label={<UserAvatarContainer className="user-menu__toggler" email={email} title={userName} />}
      buttonTestId={TestID.UserMenuToggleButton}
      userMenuTestId={TestID.UserMenu}
      closeOnInteraction={false}
    >
      {/* @ts-ignore */}
      {children}
    </MenuToggler>
  </HeaderButton>
);
